<div class="container-group">
  <h2 mat-dialog-title>Edit Trip Schedule</h2>
  <mat-dialog-content class="dialog-content custom-page-scroll">
    <div class="">
      <div class="trip-header-info">
        <span><b>Trip ID:</b> {{ tripData.tripId }}</span>
        <span><b>Block ID:</b> {{ tripData.blockId }}</span>
      </div>
      <div class="trip-header">
        <div class="trip-form main">
          <div class="form-text">Assign Vehicle:</div>
          <mat-form-field
            appearance="outline"
            style="width: 180px"
            subscriptSizing="dynamic"
            hideRequiredMarker
            floatLabel="always">
            <mat-label>Vehicle ID</mat-label>
            <mat-select
              name="vehicle"
              placeholder="Select Vehicle"
              [(ngModel)]="tripData.vehicleId">
              <mat-option *ngFor="let bus of buses" [value]="bus">
                {{ bus }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="trip-form">
          <div class="form-text">Set Offset:</div>
          <div class="trip-info-row">
            <mat-form-field
              appearance="outline"
              style="width: 60px"
              subscriptSizing="dynamic"
              hideRequiredMarker
              floatLabel="always">
              <mat-select name="offsetOperation" [(ngModel)]="offsetValue">
                <mat-option *ngFor="let ops of offsetOperations" [value]="ops">
                  {{ ops }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              style="width: 80px"
              appearance="outline"
              subscriptSizing="dynamic"
              hideRequiredMarker
              floatLabel="always">
              <mat-label>Minutes</mat-label>
              <input
                matInput
                name="minutes"
                format="number"
                min="0"
                [(ngModel)]="offsetMinutes" />
            </mat-form-field>
            <!-- <mat-form-field
              style="width: 80px"
              appearance="outline"
              subscriptSizing="dynamic"
              hideRequiredMarker
              floatLabel="always">
              <mat-label>Seconds</mat-label>
              <input
                matInput
                name="seconds"
                format="number"
                min="0"
                max="59"
                [(ngModel)]="offsetSeconds" />
            </mat-form-field> -->
          </div>
        </div>
      </div>
      <div
        class="trip-schedule"
        [ngClass]="{
          'skip-trip': skipTrip
        }">
        <div class="schedule-header">
          <div class="center-cell"></div>
          <div class="center-cell">Stop ID</div>
          <div>Stop Name</div>
          <div class="center-cell">Time</div>
          <div class="center-cell" *ngIf="skipTrip">Skip</div>
        </div>
        <div class="schedule-row" *ngFor="let stop of tripData.stops">
          <ng-container *ngIf="stop.stopSequence">
            <div class="center-cell">
              <div class="stop-sequence">{{ stop.stopSequence }}</div>
            </div>
            <div class="center-cell cell">{{ stop.stopId }}</div>
            <div class="stop-cell cell">{{ stop.stopName }}</div>
            <div class="center-cell cell">
              {{
                stop.schArrTime
                  | mockOffsetTimeEdit: offsetValue : offsetMinutes : 0
              }}

              <!-- <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                hideRequiredMarker
                floatLabel="always">
                <input
                  matInput
                  name="selected_time_B"
                  format="24"
                  [disableClick]="true"
                  [(ngModel)]="stop.schArrTime"
                  [ngxMatTimepicker]="pickerB" />
                <mat-icon matSuffix (click)="pickerB.open()">
                  watch_later
                </mat-icon>
              </mat-form-field>
              <ngx-mat-timepicker
                #pickerB
                [disableClick]="true"></ngx-mat-timepicker> -->
            </div>
            <div class="center-cell cell" *ngIf="skipTrip">
              <mat-checkbox [(ngModel)]="stop.skip"></mat-checkbox>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onEdit()">
      Save
    </button>
  </mat-dialog-actions>
</div>
